module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carte-conge",
    class: {
      skeleton: !_vm.dataReady
    },
    style: (_vm.dataReady ? {
      backgroundColor: _vm.compteur.backgroundColor
    } : {}),
    attrs: {
      "data-testid": 'carteConge-section-' + _vm.typeConge
    }
  }, [_c('div', {
    staticClass: "carte-header"
  }, [_c('h2', {
    class: {
      skeleton: !_vm.dataReady
    },
    attrs: {
      "data-testid": "carteConge-title"
    }
  }, [_vm._v(_vm._s(_vm.dataReady ? _vm.compteur.title : ''))]), _vm._v(" "), (_vm.typeConge && (_vm.typeConge == _vm.TypeCongeCompteurEnum.NMoins1 || _vm.typeConge == _vm.TypeCongeCompteurEnum.N)) ? _c('div', {
    staticClass: "tooltip-container",
    attrs: {
      "data-testid": "carteConge-tooltip"
    },
    on: {
      "mouseenter": function($event) {
        _vm.showTooltip = true
      },
      "mouseleave": function($event) {
        _vm.showTooltip = false
      }
    }
  }, [_c('i', {
    staticClass: "ri-information-fill ri-lg",
    class: {
      skeleton: !_vm.dataReady
    }
  }), _vm._v(" "), (_vm.showTooltip) ? _c('div', {
    staticClass: "custom-tooltip"
  }, [_c('span', [_vm._v(_vm._s(_vm.getTooltipText))]), _vm._v(" "), _c('span', {
    staticClass: "year"
  }, [_vm._v(_vm._s(_vm.anneeCongeText))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "carte-body"
  }, [_c('div', {
    staticClass: "body-left"
  }, [_c('div', {
    staticClass: "body-data"
  }, [_c('div', {
    staticClass: "bloc-data"
  }, [_c('h3', {
    staticClass: "data-joursRestant",
    class: {
      skeleton: !_vm.dataReady
    },
    style: (_vm.dataReady ? {
      color: _vm.compteur.data.joursRestantsColor
    } : {}),
    attrs: {
      "data-testid": "carteConge-nbJoursRestants"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dataReady ? _vm.formatNumber(this.compteur.data.joursRestants) : '') + "\n                    ")]), _vm._v(" "), _c('h3', {
    staticClass: "libelle-joursRestant",
    class: {
      skeleton: !_vm.dataReady
    },
    style: (_vm.dataReady ? {
      color: _vm.compteur.data.joursRestantsColor
    } : {})
  }, [_vm._v("\n                        " + _vm._s(_vm.dataReady ? 'J. restants' : '') + "\n                    ")])]), _vm._v(" "), _c('span', {
    class: {
      skeleton: !_vm.dataReady
    },
    attrs: {
      "data-testid": "carteConge-nbJoursAcquis"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.dataReady ? '/' + _vm.formatNumber(_vm.compteur.data.joursAcquis) : '') + "\n                    "), _c('span', [_vm._v(_vm._s(_vm.dataReady ? 'acquis' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "left-details"
  }, [_c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "dot",
    class: {
      skeleton: !_vm.dataReady
    },
    style: (_vm.dataReady ? {
      backgroundColor: _vm.compteur.data.joursPosesColor
    } : {})
  }), _vm._v(" "), _c('h4', {
    class: {
      skeleton: !_vm.dataReady
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dataReady ? 'Posés' : '') + "\n                        "), _c('span', {
    style: (_vm.dataReady ? {
      color: _vm.compteur.data.joursPosesColor
    } : {}),
    attrs: {
      "data-testid": "carteConge-nbJoursPoses"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.dataReady ? _vm.formatNumber(_vm.compteur.data.joursPoses) : '') + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "dot",
    class: {
      skeleton: !_vm.dataReady
    },
    style: (_vm.dataReady ? {
      backgroundColor: _vm.compteur.data.joursPrisColor
    } : {})
  }), _vm._v(" "), _c('h4', {
    class: {
      skeleton: !_vm.dataReady
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dataReady ? 'Pris' : '') + "\n                        "), _c('span', {
    attrs: {
      "data-testid": "carteConge-nbJoursPris"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.dataReady ? _vm.formatNumber(_vm.compteur.data.joursPris < 0 ? 0 : _vm.compteur.data.joursPris) : '') + "\n                        ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "body-right"
  }, [_c('div', {
    staticClass: "progress-circle"
  }, [(_vm.dataReady) ? _c('CircularProgress', {
    attrs: {
      "progressList": _vm.progressList,
      "backgroundColor": _vm.compteur.backgroundColor
    }
  }) : _c('div', {
    staticClass: "skeleton skeleton-circular"
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49728ac0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsencesV2/carteConge/carteConge.vue.html
// module id = s1nu
// module chunks = 2